export const ROY_PHOTO =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_deal-killer/artifacts/v76lajf5_Roy%20Buncome.webp";

export const ROY_PHOTO_BW =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_deal-killer/artifacts/egrad5oj_RoyBuncomeB_W.png";

export const IMAGES = {
  boardroom:
    "https://images.unsplash.com/photo-1638262052640-82e94d64664a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA2MTJ8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBkZWFsJTIwbmVnb3RpYXRpb24lMjBoYW5kc2hha2UlMjBleGVjdXRpdmUlMjBtZWV0aW5nJTIwYm9hcmR8ZW58MHx8fHwxNzkwMTIxODIyfDA&ixlib=rb-4.1.0&q=85",
};

export const CALENDLY_URL =
  "https://calendly.com/collabignite_roybuncome?hide_gdpr_banner=1&background_color=f8f5ef&text_color=131a26&primary_color=a8842c";

export const LINKEDIN_URL = "https://www.linkedin.com/in/roybuncome";
export const CONTACT_EMAIL = "yestosuccess@collabignite.com";
export const PHONE = "(904) 410-9000";

export const STATS = [
  { value: "3", label: "Companies exited" },
  { value: "$30M to $100M", label: "Exits architected" },
  { value: "25+", label: "Years of deal rooms and pattern recognition" },
  { value: "$4M to $8M", label: "What your first raise should expect" },
];

export const MARQUEE_ITEMS = [
  "Capital Architecture",
  "Deal Execution",
  "Market Entry",
  "Strategic Partnerships",
  "Exit Strategy",
  "Boardroom Negotiation",
  "Ecosystem Access",
  "Competitive Positioning",
];

export const MANIFESTO = [
  {
    num: "01",
    title: "The Architect",
    body: "Your deal gets designed before it ever gets pitched. Who sits at the table, what is on it, and how it closes. You walk in holding a structure that was built to be said yes to.",
  },
  {
    num: "02",
    title: "The Wingman",
    body: "Your raise gets a wingman who reads the room in seconds. You find out who can actually write the check, and you meet them with your story sharpened to a blade.",
  },
  {
    num: "03",
    title: "The Assassin",
    body: "Your competitors become the target. Call it corporate assassination: positioning, speed, and deals that take their oxygen before they know the room has changed.",
  },
  {
    num: "04",
    title: "The Anchor",
    body: "You get steady hands when the negotiation turns volatile. No flinching, no folding. Your interests held to the last line of the agreement, every single time.",
  },
];

export const NETWORK_STATS = [
  { value: "1,400+", label: "Elite operators" },
  { value: "320+", label: "Capital investors" },
  { value: "60+", label: "Enterprise partners" },
  { value: "220+", label: "Founders advised" },
];

export const ECOSYSTEM_FORMULA = [
  "People",
  "Strategy",
  "Technology",
  "Resources",
  "Opportunity",
];

export const SERVICES = [
  {
    title: "Capital Raise Architecture",
    body: "Your raise gets structured so the right money says yes: terms, timing, narrative, and a sequence of conversations that builds momentum instead of burning it. First raise? Expect $4M to $8M, sized right.",
  },
  {
    title: "Deal Structuring & Negotiation",
    body: "You walk in with a deal designed to hold: complex terms, cross-functional teams, high stakes. And you know who across the table can actually close before you sit down.",
  },
  {
    title: "Market Entry & Competitive Positioning",
    body: "You take ground your competitors thought was theirs. We find where they are weak, and you occupy it before they react.",
  },
  {
    title: "Strategic Partnerships & Deal Flow",
    body: "You get revenue ecosystems built on real relationships. Partnerships that move your P&L, not logos on a slide.",
  },
  {
    title: "Boardroom Representation",
    body: "You never walk into a high-stakes room alone. You get a wingman who is brilliant on his feet, sitting beside you when the deal is won or lost.",
  },
  {
    title: "Exit Strategy & Execution",
    body: "Your exit gets designed years before it happens. Positioning to closing table: three companies exited, $30M to $100M.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Mr. Buncome has introduced me into a world of opportunities I would otherwise never see. If you want to be a part of the arena of influence, he can open the door for you.",
    name: "John Bishop",
    role: "Business Owner & Client",
  },
  {
    quote:
      "I have recommended Mr. Buncome to my clients on many occasions. Each time, my clients have thanked me for making the connection.",
    name: "Katina Phillips",
    role: "Senior Vice President, Commercial Banking",
  },
  {
    quote:
      "The connections and insight from his network allowed me to gain more knowledge with helping business owners achieve their goals to be successful.",
    name: "Chris Tomlinson",
    role: "National Sales Manager, American Bank",
  },
  {
    quote:
      "He shows great attention to detail. He is personable and has a spotless reputation. I am proud to recommend him to my friends and colleagues.",
    name: "Mary Fisher",
    role: "Client",
  },
];

export const TIMELINE = [
  {
    era: "1995 to Present",
    title: "Business Analyst, Sylvester Project & Business Development Corp.",
    body: "Direction for business improvement from conception, through pre-startup, to expansion. Thirty years of pattern recognition you get to borrow.",
  },
  {
    era: "2015 to Present",
    title: "Business Development Manager, CollabIgnite",
    body: "Coordinating resources to get businesses off the ground, handle major projects, and accomplish something fundamentally extraordinary.",
  },
  {
    era: "2018 to 2024",
    title: "Advisory Board, Small Business Development Center at UNF",
    body: "Serving Florida's principal provider of business assistance, helping founders become fundable and grow with discipline.",
  },
  {
    era: "2021 to Present",
    title: "Division Leader, Financial Services",
    body: "Leading growth across financial services: capital strategy, deal flow, and market expansion.",
  },
];

export const CORE_VALUES = [
  { title: "Collaboration", body: "Success is built through relationships. You never build alone again." },
  { title: "Execution", body: "Ideas create possibilities. Execution creates results. You get both, in that order." },
  { title: "Integrity", body: "Trust is the foundation of every partnership. Yours is protected like it is our own." },
  { title: "Innovation", body: "Technology, including AI, deployed as your competitive advantage." },
  { title: "Growth", body: "Always improve, expand, and evolve. Measurable growth, not motion." },
  { title: "Impact", body: "Your success should improve your community. Wealth, jobs, and legacy." },
];

export const IMPACT_GOALS = [
  { value: "100", label: "startups to reach $100K+" },
  { value: "50", label: "businesses to reach $500K+" },
  { value: "20", label: "companies to reach $5M to $10M+" },
];

export const PHILOSOPHY = [
  {
    title: "Clarity",
    body: "Understand where you are. What problem do you solve, who is your customer, what makes you different, and what is your revenue model.",
  },
  {
    title: "Focus",
    body: "Identify the highest-value activities. What actually moves revenue, what gets eliminated, and where your resources go.",
  },
  {
    title: "Action",
    body: "Execute consistently. Who owns the next step, what happens this week, and what metric proves progress.",
  },
];

export const PHASES = [
  {
    num: "01",
    title: "Room Assessment",
    body: "You start with brutal clarity: your position, your numbers, your story, and who in your market can actually move the outcome. You leave knowing exactly where you stand. If you are raising for the first time, this is where your $4M to $8M target gets set.",
  },
  {
    num: "02",
    title: "Deal Architecture",
    body: "Your deal gets designed: the raise, the partnership, the market entry, the exit path. Terms, sequence, and narrative engineered so the deal is already strong before anyone negotiates it.",
  },
  {
    num: "03",
    title: "The Right Introductions",
    body: "Doors open to people who can write checks and sign papers. You walk through them prepared, sharpened, and undeniable.",
  },
  {
    num: "04",
    title: "Close & Exit",
    body: "You never close alone. Negotiation, terms, signatures: steady hands, sharp edges, and your interests held until the ink is dry.",
  },
];

export const FAQ = [
  {
    q: "What happens in the 20-minute call?",
    a: "A direct working conversation. You bring the situation: raise, deal, market, competitor, exit. You get a fast, honest read on whether it can be won, how, and what your first move should be. No pitch deck required.",
  },
  {
    q: "How big should my first raise be?",
    a: "Most founders should expect $4M to $8M for a first raise. Size it wrong in either direction and it costs you, so getting your number right is one of the first things we do together.",
  },
  {
    q: "How should I prepare?",
    a: "Know your numbers, know your ask, and be ready to say plainly what is blocking you. Twenty minutes is plenty when both sides are direct.",
  },
  {
    q: "Who do you typically work with?",
    a: "Founders raising capital, scale-ups entering new markets, and operators preparing for exit. Decisive people do best here.",
  },
  {
    q: "What does an engagement look like after the call?",
    a: "If there is a fit, you get a clear proposal: scope, timeline, and compensation aligned with your outcome. You know exactly what working together means before anything starts.",
  },
];

export const CREATIVE_ASSETS = [
  { title: "Talent", body: "Your creative ability is an economic asset. It gets treated like one." },
  { title: "Audience", body: "Your attention and community can create real commercial opportunities." },
  { title: "Intellectual Property", body: "Your music, films, characters, concepts, content, brands, designs, and stories can become long-term assets." },
  { title: "Relationships", body: "Your network can create partnerships, sponsorships, distribution, production, and business opportunities." },
  { title: "Reputation", body: "Your credibility and influence open doors that traditional marketing cannot." },
];

export const CREATIVE_STAGES = [
  {
    num: "01",
    title: "Clarity",
    body: "Understand what you have.",
    items: ["Talent", "Audience", "Brand", "IP", "Revenue", "Relationships", "Opportunities"],
  },
  {
    num: "02",
    title: "Position",
    body: "Determine how the market should see you.",
    items: ["Personal brand", "Creative brand", "Business positioning", "Offers", "Market identity", "Differentiation"],
  },
  {
    num: "03",
    title: "Monetize",
    body: "Identify the ways you can create revenue.",
    items: ["Sponsorships", "Brand partnerships", "Licensing", "Merchandise", "Events", "Digital products", "Appearances", "Memberships"],
  },
  {
    num: "04",
    title: "Activate",
    body: "Turn opportunities into action.",
    items: ["Partnerships", "Strategic introductions", "Sponsorship opportunities", "Campaigns", "Projects", "Revenue initiatives"],
  },
  {
    num: "05",
    title: "Scale",
    body: "Build the infrastructure growth demands.",
    items: ["Systems", "Team", "Technology", "Processes", "Capital readiness", "IP strategy", "Multiple revenue streams"],
  },
];

export const CREATIVE_WHO = [
  { title: "Entertainers", body: "Actors, musicians, performers, comedians, hosts, and personalities." },
  { title: "Creators", body: "YouTubers, influencers, podcasters, digital creators, and educators." },
  { title: "Artists", body: "Visual artists, designers, photographers, and fashion creatives." },
  { title: "Producers", body: "Film, television, music, events, media, and entertainment producers." },
  { title: "Creative Founders", body: "Entrepreneurs building companies around creative assets." },
  { title: "Creative Businesses", body: "Agencies, studios, production companies, and entertainment enterprises." },
];

export const CREATIVE_BUILD = [
  { title: "Personal Brand", body: "Turn recognition into positioning and opportunity." },
  { title: "Creative Business", body: "Build the business structure behind the talent." },
  { title: "Revenue Engine", body: "Develop multiple revenue pathways." },
  { title: "Sponsorship", body: "Create professional opportunities for brands and sponsors." },
  { title: "Partnerships", body: "Identify and activate strategic relationships." },
  { title: "Intellectual Property", body: "Identify opportunities surrounding your creative assets." },
  { title: "Business Development", body: "Create pathways to customers, partners, markets, and opportunities." },
  { title: "Capital Readiness", body: "Prepare the business for the right capital conversations." },
  { title: "Systems", body: "Create repeatable processes that let the business scale." },
  { title: "Technology", body: "Use technology and AI where it creates meaningful leverage." },
];

export const CREATIVE_BEFORE = [
  "Talent",
  "Audience",
  "Opportunities",
  "Scattered Revenue",
  "Founder Dependency",
  "Inconsistent Growth",
];

export const CREATIVE_AFTER = [
  "Talent + Brand + IP + Audience",
  "Business Infrastructure",
  "Multiple Revenue Opportunities",
  "Strategic Partnerships",
  "Scalable Creative Enterprise",
];

export const CREATIVE_3G = [
  {
    title: "Goals",
    body: "Where are you going? Define the business and creative objectives first, so every move has a target.",
  },
  {
    title: "Guidance",
    body: "Who can help you get there? Strategy, expertise, mentors, advisors, and resources connected to your objectives.",
  },
  {
    title: "Groups",
    body: "Who needs to be in your ecosystem? Brands, sponsors, investors, producers, distributors, customers, creatives, and strategic partners.",
  },
];

export const CREATIVE_REVENUE_MAP = [
  "Creative Talent",
  "Personal Brand",
  "Audience",
  "Content",
  "Sponsorships",
  "Brand Partnerships",
  "Products",
  "Merchandise",
  "Licensing",
  "Events",
  "IP",
  "Strategic Investments",
  "Creative Enterprise",
];

export const CREATIVE_IP_LIST = [
  "Licensing", "Adaptation", "Merchandising", "Distribution", "Brand partnerships",
  "Content extensions", "Character development", "Publishing", "Media",
  "Product development", "Strategic collaborations",
];

export const CREATIVE_OFFERS = [
  {
    name: "Ignite Creative",
    audience: "For emerging creatives",
    promise: "Turn talent into a business.",
    focus: ["Business foundation", "Positioning", "Brand", "Revenue opportunities", "Growth roadmap"],
    cta: "Ignite My Business",
  },
  {
    name: "Accelerate Creative",
    audience: "For established creatives",
    promise: "Turn audience and relationships into revenue opportunities.",
    focus: ["Monetization", "Partnerships", "Sponsorships", "Business development", "Systems", "Growth"],
    cta: "Accelerate My Business",
  },
  {
    name: "Ascend Creative",
    audience: "For creative enterprises",
    promise: "Turn relationships, intellectual property, and opportunities into scalable ventures.",
    focus: ["Strategic growth", "Enterprise development", "Capital readiness", "IP commercialization", "Expansion"],
    cta: "Explore Ascend",
  },
];

export const CREATIVE_DIFFERENCE = [
  { title: "Strategy", body: "Know what you are building." },
  { title: "Business Development", body: "Create opportunities." },
  { title: "Relationships", body: "Connect with the right people." },
  { title: "Monetization", body: "Identify revenue pathways." },
  { title: "Infrastructure", body: "Build systems that support growth." },
  { title: "Execution", body: "Move from idea to action." },
];

export const CREATIVE_QUALIFY = [
  "You are serious about building a business around your creative work",
  "You want more than exposure",
  "You want to develop multiple revenue opportunities",
  "You want to build strategic partnerships",
  "You want to understand the business value of your creative assets",
  "You are ready to become more intentional about your growth",
  "You are willing to execute",
];

export const CREATIVE_CATEGORIES = [
  "Music", "Film", "Television", "Acting", "Modeling", "Fashion", "Photography",
  "Visual Art", "Design", "Content Creation", "Podcasting", "Events", "Production",
  "Agency", "Other",
];

export const CREATIVE_STAGES_SELECT = ["Just Starting", "Building", "Established", "Scaling", "Enterprise"];

export const CREATIVE_GOALS = [
  "Increase Revenue", "Find Sponsors", "Develop Partnerships", "Monetize IP",
  "Build My Brand", "Launch a Project", "Build a Company", "Raise Capital",
  "Expand Markets", "Other",
];
